import script from "./OurProductDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OurProductDetail.vue?vue&type=script&setup=true&lang=js"

import "./OurProductDetail.vue?vue&type=style&index=0&id=5cd7a052&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd7a052"]])

export default __exports__